<template>
  <div class="CustomModel" v-if="show">
    <div class="TipsModel">
      <div class="TipsBox">
        <div class="header">
          <div class="title">{{ $t("windowsRecognitionTitle") }}</div>
          <img
            @click="handleToClose"
            class="close"
            src="../../../assets/images/cancel.png"
            alt=""
          />
        </div>
        <div class="content">
          <div class="item">{{ $t("windowsStepOne") }}</div>
          <div class="item" v-html="$t('windowsStepTwo')"></div>
        </div>
        <div class="footer">
          <div class="btn" @click="handleToClose">{{ $t("gotIt") }}</div>
        </div>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<style scoped lang="less">
.CustomModel {
  .TipsModel {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 2005;
    text-align: center;

    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }

    .TipsBox {
      background-color: #fff;
      width: 720px;
      height: auto;
      max-height: calc(100vh - 32px);
      z-index: 2005;
      display: inline-flex;
      flex-direction: column;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 24px;
      font-size: 18px;
      text-align: left;
      overflow: hidden;
      backface-visibility: hidden;

      .header {
        width: 100%;
        padding: 42px 24px 16px 24px;
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .title {
          width: 100%;
          text-align: center;
          font-weight: 600;
          font-size: 24px;
          line-height: 32px;
          color: 000000;
        }

        img {
          width: 44px;
          height: 44px;
          cursor: pointer;
        }
      }

      .content {
        margin: 12px 0;
        padding: 4px 42px;
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        color: rgba(80, 80, 80, 1);

        .item {
          font-size: 20px;
          text-align: justify;
          line-height: 28px;

          a {
            color: #2d4fff;
          }
        }
      }

      .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px 42px 24px 24px;

        .btn {
          min-width: 124px;
          height: 54px;
          border-radius: 100px;
          padding: 16px 32px;
          box-sizing: border-box;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-weight: 600;
          color: #fff;
          background-color: #2417e4;
          cursor: pointer;

          &:hover {
            background-color: rgba(97, 122, 255, 1);
          }

          &:active {
            background-color: #243fcc;
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 100;
  }
}
</style>

<script>
export default {
  props: {
    show: Boolean,
    onCancel: Function,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleToClose() {
      this.onCancel && this.onCancel();
    },
  },
};
</script>
